export enum KeyboardActions {
  PickUp = 'PickUp',
  DropOff = 'DropOff',
  ZoomIn = 'ZoomIn',
  ZoomOut = 'ZoomOut',
  RotateLeft = 'RotateLeft',
  RotateRight = 'RotateRight',
  ChangeMapStyle = 'ChangeMapStyle',
  OpenStorageArea = 'OpenStorageArea',
  OpenInventory = 'OpenInventory',
  ToggleStorageAreaFull = 'ToggleStorageAreaFull',
  Undo = 'Undo',
  CreateStorageArea = 'CreateStorageArea',
  SelectNextNearbyStorageArea = 'SelectNextNearbyStorageArea',
  SelectPreviousNearbyStorageArea = 'SelectPreviousNearbyStorageArea'
}

export interface KeyPress {
  key: string | undefined;
  code: string | undefined;
  altKey: boolean | undefined;
  ctrlKey: boolean | undefined;
  shiftKey: boolean | undefined;
  metaKey: boolean | undefined;
  timestamp: number;
}

export interface Keybind {
  key: string | undefined;
  code: string | undefined;
  altKey: boolean | undefined;
  ctrlKey: boolean | undefined;
  shiftKey: boolean | undefined;
  metaKey: boolean | undefined;
}

export interface FormKeybind extends Keybind {
  actionText: string;
  keyText: string;
}

export interface FormKeyboardAction {
  action: KeyboardActions;
  keybind: FormKeybind;
  changed: boolean;
}

export interface KeyboardAction {
  action: KeyboardActions | null;
  timestamp: number;
}

export const defaultBindings: Record<KeyboardActions, Keybind> = {
  [KeyboardActions.PickUp]: {
    key: '6',
    code: 'Digit6',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.DropOff]: {
    key: '7',
    code: 'Digit7',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.ZoomIn]: {
    key: 'W',
    code: 'KeyW',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.ZoomOut]: {
    key: 'S',
    code: 'KeyS',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.RotateLeft]: {
    key: 'Q',
    code: 'KeyQ',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.RotateRight]: {
    key: 'E',
    code: 'KeyE',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.ChangeMapStyle]: {
    key: '3',
    code: 'Digit3',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.OpenStorageArea]: {
    key: '1',
    code: 'Digit1',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.OpenInventory]: {
    key: '2',
    code: 'Digit2',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.ToggleStorageAreaFull]: {
    key: '4',
    code: 'Digit4',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.Undo]: {
    key: 'Z',
    code: 'KeyZ',
    ctrlKey: true,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.CreateStorageArea]: {
    key: '9',
    code: 'Digit9',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
  [KeyboardActions.SelectNextNearbyStorageArea]: {
    key: '+',
    code: 'NumpadAdd',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },

  [KeyboardActions.SelectPreviousNearbyStorageArea]: {
    key: '-',
    code: 'NumpadSubtract',
    ctrlKey: false,
    altKey: false,
    shiftKey: false,
    metaKey: false,
  },
};
